<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
   item: Object,
   classItems: {
      type: Array,
      required: false,
      default: () => []
   },
   mode: {
      type: Array,
      default: () => []
   },
})

const videoLoaded = ref(false)

function handleLoad() {
   videoLoaded.value = true
}

// Функция для определения MIME-типа на основе расширения файла
const getMimeType = (url) => {
   if (!url) return ''
   const extension = url.split('.').pop().toLowerCase()
   switch (extension) {
      case 'webm':
         return 'video/webm'
      case 'mp4':
         return 'video/mp4'
      case 'ogg':
         return 'video/ogg'
      case 'avi':
         return 'video/x-msvideo'
      case 'mov':
         return 'video/quicktime'
      default:
         return ''
   }
}

// const isIphone = computed(() => {
//    return /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
// })

const videoUrl = computed(() => {
   return props.item.url
   // return isIphone.value ? props.item.url : props.item.urlIphone
})
const videoType = computed(() => getMimeType(videoUrl.value))
</script>

<template>
   <video :class="[!mode.includes('full_size') ? 'video_item item item__impress activeItemShadow' : '', ...classItems]"
      autoplay loop muted playsinline @loadeddata="handleLoad" v-show="videoLoaded">
      <source :src="videoUrl" :type="videoType" />
   </video>
   <div :class="['tempItem item', mode.includes('no_skeleton') ? '' : 'activeItemShadow']" v-if="!videoLoaded">&nbsp;</div>
</template>

<style scoped>
.video_item {
   max-height: var(--itetm_height);
}

.tempItem {
   height: var(--itetm_height) !important;
   min-width: var(--itetm_min-width) !important;
}

.activeItemShadow {
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);
	border-radius: var(--itetm_border-radius);
}
</style>
